import SvgIcon from "@mui/material/SvgIcon";
import { ReactComponent as MangadexIcon } from "./nhentai-icon.svg";

const Nhentai = (props: any) => {
  return (
    <SvgIcon component={ MangadexIcon } {...props} />
  );
}

export default Nhentai;